import { stableStringify } from "./stableStringify";

export function areObjectsEqual(obj1: any, obj2: any): boolean {
  if (obj1 === obj2) return true;
  if (!obj1 || !obj2) return false;

  try {
    return stableStringify(obj1) === stableStringify(obj2);
  } catch (e) {
    // Fallback to simple comparison if stringify fails
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }
}
